require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2004-03-13-integration.json") })
        }
      }, "path---articles-2004-03-13-integration");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2004-03-13-integration!./.cache/json/articles-2004-03-13-integration.json
// module id = 346
// module chunks = 231608221292675